// Google Funding Choices injects a "Privacy and cookie settings" bubble
// (#ft-reg-bubble) and a floating compliance toolbar (.ft-menu) on every
// page load, both inside a shadow root — so a normal document.querySelector
// misses them. Real consent is collected by the separate full CMP modal;
// these elements just float over game UI and break the layout. Walk shadow
// roots to find and remove them. Poll periodically because Funding Choices
// can re-render after our initial pass.

function findInShadows(
  selector: string,
  root: Document | ShadowRoot = document,
): Element | null {
  const found = root.querySelector(selector);
  if (found) return found;
  for (const el of root.querySelectorAll("*")) {
    if (el.shadowRoot) {
      const inner = findInShadows(selector, el.shadowRoot);
      if (inner) return inner;
    }
  }
  return null;
}

const SELECTORS = ["#ft-reg-bubble", ".ft-menu"];

export function autoDismissConsentBubble(): void {
  const tryDismiss = (): void => {
    for (const sel of SELECTORS) {
      findInShadows(sel)?.remove();
    }
  };
  tryDismiss();
  window.setInterval(tryDismiss, 500);
}
